<template>
  <div class="mb-5">
    <MarketOverallIncomeMonthlyComponent :isMainLoading="isMainLoading" :tabType="tab"/>
  </div>
</template>

<script>
import MarketOverallIncomeMonthlyComponent from "@/components/MarketOverallIncomeMonthly.component";
export default {
  components: {
    MarketOverallIncomeMonthlyComponent
  },
  props: {
    isMainLoading: Boolean
  },
  data() {
    return {
      tab: this.$globalCurrencyCode
    }
  },
};
</script>